export function getDriverSession() {
  try {
    return JSON.parse(localStorage.getItem("dh_driver_user") || "null");
  } catch {
    return null;
  }
}

export function saveDriverSession(driver) {
  if (driver) localStorage.setItem("dh_driver_user", JSON.stringify(driver));
  else localStorage.removeItem("dh_driver_user");
}

export function registerDriverPushToken(driver) {
  const token = localStorage.getItem("deliveryHuarazCustomerPushToken");
  if (!driver?.auth_token || !token) return Promise.resolve();
  return fetch("/public/api/notifications/register-user", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${driver.auth_token}`,
    },
    body: JSON.stringify({ push_token: token }),
  }).catch(() => {});
}
